module.exports = __webpack_public_path__ + "static/media/quote.ca18655d.svg";